function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "60",
  height: "60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h60v60H0z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.09 10.5h20.592c8.4 0 13.178 7.852 13.178 12.706 0 1.739.005 1.97.01 2.233.007.344.015.74.015 4.628 0 7.406-5.936 13.573-12.956 13.573h-21.43L6 50.377s.05-21.177.05-27.047c0-5.87 5.049-12.83 14.04-12.83zm25.145 3.433a10.112 10.112 0 00-4.553-1.055H20.09c-1.826 0-3.528.332-5.06.989a11.081 11.081 0 00-3.635 2.502c-1.866 1.935-2.981 4.538-2.981 6.961 0 4.276-.027 16.813-.04 23.208l10.073-5.028.497-.248H40.928c5.742 0 10.592-5.127 10.592-11.195 0-3.863-.008-4.26-.014-4.58v-.002c-.005-.277-.01-.52-.01-2.279 0-.912-.25-2.023-.701-3.13a12.572 12.572 0 00-2.15-3.474c-.996-1.14-2.143-2.037-3.41-2.669zM25.442 25.86c0 1.764-1.397 3.193-3.12 3.193-1.724 0-3.12-1.43-3.12-3.193 0-1.763 1.396-3.192 3.12-3.192 1.723 0 3.12 1.43 3.12 3.192zm12.121 3.193c1.724 0 3.12-1.43 3.12-3.193 0-1.763-1.396-3.192-3.12-3.192-1.723 0-3.12 1.43-3.12 3.192 0 1.764 1.397 3.193 3.12 3.193z",
  fill: "#0272B6"
}));